<template>
  <div class="main" id="main">
    <div class="p-page__section theme--light--alt">
      <Nav></Nav>
      <Header v-if="!isPanchKalyanakRoute"></Header>
      <!-- <section class="p-page__section__inner inner-view">-->
      <!-- <Pk v-if="isPanchKalyanakRoute"></Pk>-->
      <section>
        <router-view />
      </section>
      <Footer v-if="!isPanchKalyanakRoute"></Footer>
      <go-top :rel="'noopener'"></go-top>
      <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    </div>
  </div>
</template>

<script>
//import { mapActions } from "vuex";
import { constants } from "@/lib/constants";
import Nav from "@/components/layout/Nav";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import GoTop from "@inotom/vue-go-top";
import { eventBus } from "@/eventBus";

// Import component
import Loading from "vue-loading-overlay";
//import Pk from "./components/common/Pk.vue";

export default {
  name: "App",
  data() {
    return {
      isLoading: false,
      fullPage: true
    };
  },
  computed: {
    isPanchKalyanakRoute() {
      const normalizedPath = this.$route.path.toLowerCase();
      return normalizedPath === "/" || normalizedPath.startsWith("/panchkalyanak");
    }
  },
  created() {
    document.title = constants.APP_TITLE;
    //this.initData();

    eventBus.$on("overlayLoadingStart", () => {
      this.isLoading = true;
    });

    eventBus.$on("overlayLoadingEnd", () => {
      this.isLoading = false;
    });
  },
  components: {
    Nav,
    Header,
    Footer,
    GoTop,
    Loading,
    //Pk
  },
  methods: {
    //...mapActions("newsFeed", ["loadNewsFeed"]),
    //...mapActions("cards", ["loadCards"]),
    //...mapActions("documents", ["loadDocuments"]),
    //...mapActions("events", ["loadEvents"]),

    async initData() {
      await this.loadNewsFeed();
      await this.loadCards();
      await this.loadDocuments();
      await this.loadEvents();
    }
  }
};
</script>
